(() => {
  // function clamp(value, min, max) {
  //   return Math.min(Math.max(value, min), max);
  // }

  // function positionPanel(detailsEl, skipTransition = false) {
  //   if (!detailsEl || !detailsEl.open) return;
  //   const summary = detailsEl.querySelector('summary');
  //   const panel = detailsEl.querySelector('.mega-menu__content');
  //   if (!summary || !panel) return;

  //   // Mark as positioned so CSS overrides apply
  //   panel.classList.add('is-positioned');

  //   // Temporarily disable transitions for initial positioning to prevent slide animation
  //   if (skipTransition) {
  //     panel.style.transition = 'none';
  //   }

  //   // Reset sizing before measuring
  //   // panel.style.width = 'auto';
  //   panel.style.left = '0px';
  //   panel.style.right = 'auto';

   
  //   const viewportPadding = 16; // px
  //   const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  //   const naturalWidth = Math.min(panel.scrollWidth, viewportWidth - viewportPadding * 2);
  //   // panel.style.width = `${naturalWidth}px`;

    
  //   const parentLeft = (panel.offsetParent && panel.offsetParent.getBoundingClientRect
  //     ? panel.offsetParent.getBoundingClientRect().left
  //     : 0);
  //   const triggerRect = summary.getBoundingClientRect();
  //   const triggerCenter = triggerRect.left + triggerRect.width / 2;
  //   const desiredLeftViewport = triggerCenter - naturalWidth / 2;
  //   const maxLeftViewport = viewportWidth - naturalWidth - viewportPadding;
  //   const clampedLeftViewport = clamp(
  //     desiredLeftViewport,
  //     viewportPadding,
  //     Math.max(maxLeftViewport, viewportPadding)
  //   );
  //   // Convert viewport-based left to the coordinate space of the offset parent
  //   const leftWithinParent = clampedLeftViewport - parentLeft;
  //   panel.style.left = `${leftWithinParent}px`;
  //   panel.style.right = 'auto';

    
  //   if (skipTransition) {
      
  //     void panel.offsetHeight;
  //     // Re-enable transitions on next frame
  //     requestAnimationFrame(() => {
  //       panel.style.transition = '';
  //     });
  //   }
  // }

  function attach(detailsEl) {
    if (!detailsEl) return;
    const summary = detailsEl.querySelector('summary');
    const panel = detailsEl.querySelector('.mega-menu__content');
    if (!summary || !panel) return;

    let hoverTimeout = null;
    let closeTimeout = null;

    // Handle hover to open
    function handleMouseEnter() {
      // Clear any pending close
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }

      // Close other open menus first to prevent flicker
      const allDetails = document.querySelectorAll('details.mega-menu');
      allDetails.forEach((otherDetails) => {
        if (otherDetails !== detailsEl && otherDetails.open) {
          otherDetails.removeAttribute('open');
        }
      });

      // Open with a small delay to prevent accidental opens
      hoverTimeout = setTimeout(() => {
        if (!detailsEl.open) {
          detailsEl.setAttribute('open', '');
        }
      }, 150); // Small delay to prevent flicker
    }

    // Handle mouse leave to close
    function handleMouseLeave() {
      // Clear any pending open
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }

      // Close with a delay to allow moving to the panel
      closeTimeout = setTimeout(() => {
        if (detailsEl.open) {
          detailsEl.removeAttribute('open');
        }
      }, 200); // Delay to allow moving to dropdown
    }

    // Also handle mouse events on the panel itself
    function handlePanelMouseEnter() {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    }

    function handlePanelMouseLeave() {
      closeTimeout = setTimeout(() => {
        if (detailsEl.open) {
          detailsEl.removeAttribute('open');
        }
      }, 200);
    }

    // Attach hover events
    summary.addEventListener('mouseenter', handleMouseEnter);
    summary.addEventListener('mouseleave', handleMouseLeave);
    panel.addEventListener('mouseenter', handlePanelMouseEnter);
    panel.addEventListener('mouseleave', handlePanelMouseLeave);
  }

  function init() {
    const allDetails = document.querySelectorAll('details.mega-menu');
    allDetails.forEach(attach);

    // // Reposition the currently open panel on resize to keep it clamped
    // window.addEventListener('resize', () => {
    //   const openDetails = document.querySelector('details.mega-menu[open]');
    //   if (openDetails) {
    //     requestAnimationFrame(() => {
    //       positionPanel(openDetails);
    //     });
    //   }
    // });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


